import React from "react";
import { IUIPropertyDefinition, applyAtPath } from "../../../common/common";
import ActionEditorLink, { IAction } from "../../../common/action-editor/ActionEditor";
import { BackgroundPositionEditor, CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, escapeUnit } from "../../../common/ui-props/common";
import IconEditor from "../../../common/icon-selector/IconEditor";
import jp from 'jsonpath'
import { ColorPallet, ColorPicker, Input, Select } from "uxp/components";
import { createDefaultPropsForWidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";
import { ImagePicker } from "lucy/common-components";

export interface IImageCardProps {
    image: string,
    imageSize: string;
    imagePosition: string;
    title: string,
    titleColor: string,
    titleSize: string,
    subtitle: string,
    subtitleColor: string,
    subtitleSize: string,
    backgroundColor?: string,
    onClick?: IAction,
}

export interface IImageCardWidgetProps {
    buttons: IImageCardProps[]
}

export function ImageCardWidgetProperty(widgetProps: IImageCardProps[], buttonType: string): IUIPropertyDefinition<IImageCardProps[]> {
    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({}, true)

    return {
        defaults: widgetProps,
        render: (props, uxpContext, data, containerId) => {

            let _props = props?.uiProps || widgetProps
            const { selectedIndex } = data
            const selectedImageCard = _props[selectedIndex] as IImageCardProps

            if(!selectedImageCard) return <></>

            return <>
                <PropertyContainer>
                    <PropertyContainerTitle>Image Card Properties</PropertyContainerTitle>

                    <PropertyGroup>
                        <PropertyGroupTitle></PropertyGroupTitle>

                        <Property>
                            <PropertyTitle>Image</PropertyTitle>
                            <ImagePicker
                                uxpContext={uxpContext}
                                imageUrl={selectedImageCard?.image}
                                onChange={s => {
                                    _props[selectedIndex].image = s
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                        <Property>
                        <PropertyTitle>Image Position</PropertyTitle>
                        <BackgroundPositionEditor
                            position={selectedImageCard?.imagePosition || ''}
                            onChange={s => {
                                _props[selectedIndex].imagePosition = s;
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Image Size</PropertyTitle>
                        <Select
                            selected={selectedImageCard.imageSize || 'cover'}
                            options={[
                                { label: 'Original Size', value: 'auto' },
                                { label: 'Fill Area', value: 'cover' },
                                { label: 'Fit Into Area', value: 'contain' }
                            ]}
                            onChange={s => {
                                _props[selectedIndex].imageSize = s;
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                        />
                    </Property>
                        <Property>
                            <PropertyTitle>Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}

                                color={selectedImageCard?.backgroundColor}
                                onChange={s => {
                                    _props[selectedIndex].backgroundColor = s
                                    props.onChange(_props)
                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Title</PropertyTitle>
                            <Input
                                value={selectedImageCard?.title || ''}
                                onChange={s => {
                                    _props[selectedIndex].title = s
                                    props.onChange(_props)

                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Title Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={selectedImageCard?.titleColor}
                                onChange={s => {
                                    _props[selectedIndex].titleColor = s
                                    props.onChange(_props)
                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Title Size (px) </PropertyTitle>
                            <Input
                                type='number'
                                value={escapeUnit(selectedImageCard.titleSize || '', 'px')}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    if (num < 8) s = '8'
                                    else if (num > 200) s = '200'

                                    _props[selectedIndex].titleSize = (s + 'px')
                                    props.onChange(_props)
                                }}
                                className="widget-designer-input"
                                inputAttr={{
                                    max: '200',
                                    min: '8'
                                }}
                            />
                        </Property>

                        <Property>
                            <Property>
                                <PropertyTitle>Subtitle</PropertyTitle>
                                <Input
                                    value={selectedImageCard?.subtitle || ''}
                                    onChange={s => {
                                        _props[selectedIndex].subtitle = s
                                        props.onChange(_props)

                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Subtitle Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={selectedImageCard?.subtitleColor}
                                    onChange={s => {
                                        _props[selectedIndex].subtitleColor = s
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Subtitle Size (px) </PropertyTitle>
                                <Input
                                    type='number'
                                    value={escapeUnit(selectedImageCard.subtitleSize || '', 'px')}
                                    onChange={s => {
                                        let num = Number(s) || 0
                                        if (num < 8) s = '8'
                                        else if (num > 200) s = '200'

                                        _props[selectedIndex].subtitleSize = (s + 'px')
                                        props.onChange(_props)
                                    }}
                                    className="widget-designer-input"
                                    inputAttr={{
                                        max: '200',
                                        min: '8'
                                    }}
                                />
                            </Property>
                        </Property>

                        <Property>
                            <PropertyTitle>On Click</PropertyTitle>
                            <ActionEditorLink
                                uiProps={props.parentUIProps}
                                action={selectedImageCard?.onClick}
                                onChange={s => {
                                    _props[selectedIndex].onClick = s
                                    props.onChange(_props)
                                }}
                                uxpContext={uxpContext}
                            />
                        </Property>
                    </PropertyGroup>
                </PropertyContainer>
            </>
        }
    }
}
